export default __webpack_public_path__ + "static/media/Jost-Black.4a135fe6.ttf";